import React, {Component} from 'react'
import {connect} from 'react-redux'
import Menu from './Menu'
import '../../css/elements/left-sidebar-1.css'
import {getSelectedCountryCode} from '../../panel-admin/common/functions/countrySetting'
import WithAjax from '../../panel-admin/common/helpers/WithAjax'


class LeftSidebar extends Component{
  intervalID = 0;
  constructor() {
    super();

    this.state = {
      dashboardData: []
    }
  }

  componentDidMount() {
    this.intervalID  = setInterval(() => {
        this.fetchDashboardData(this.props.isLoading);
    }, 5000);
  }

  componentWillUnmount(){
    clearInterval(this.intervalID);
  }

  fetchDashboardData(isLoading) {
    if(!isLoading){
      this.props.ajax.get('dashboard', true, (data) => {
        this.setState({dashboardData: data});
      }, true);
    }
  }

  render(){
    var {navigation} = this.props;
    return (
      <div>
        <div className="left-sidebar-placeholder">
          <div className="app-version"></div>
        </div>
        <div className="left-sidebar left-sidebar-1">
          <div className="wrapper">
            <div className="content">
              {navigation.map((menu, i) => (
                <div key={i} className="section">
                  <div className="section-title">{menu.title}</div>
                  <ul className="list-unstyled">
                    {menu.items.map((items, i) => <Menu key={i} items={items} dashboardData={this.state.dashboardData} />)}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(LeftSidebar))
